/**
 * 編集セッションを React に繋ぐ（索引 Issue #498 の段階 5）。
 *
 * セッション（`duelEditor/timeline/editor.js`）は自分で変更を知らせるので、ここは**知らせが来たら描き直すだけ**。
 * 状態を React 側に写さない（写すと 2 か所に真実ができて必ずずれる）。
 */
import { useEffect, useReducer } from 'react';

export function useEditorState(editor) {
  const [, force] = useReducer((n) => n + 1, 0);
  useEffect(() => (editor ? editor.subscribe(force) : undefined), [editor]);
  return editor;
}
